import type { PaymentProviderType } from "@/feature-wallet/models/payment-method-provider.mjs";

export const EVENT_PRO_CONVERSION = "EVENT_PRO_CONVERSION";

declare module "@/app/app-event-bus.mjs" {
  interface EventBusEvents {
    [EVENT_PRO_CONVERSION](data: {
      providerType: PaymentProviderType | "BOLTS";
    }): void;
  }
}
